import { useMutation } from '@debbie/common/dist/util/hooks.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import { errorNotification } from '../../../utils/errors.js';
import DateInput from '../../DateInput.js';
import UserInfoEntity from './UserInfoEntity.js';
const UserBirthdate = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const [birthdate, setBirthdate] = useState(null);
    useEffect(() => {
        if (details) {
            if (details.birthdate) {
                const parsedDate = moment(details.birthdate);
                if (parsedDate.isValid()) {
                    setBirthdate(parsedDate);
                }
                else {
                    setBirthdate(null);
                }
            }
            else {
                setBirthdate(null);
            }
        }
    }, [details]);
    const patchBirthdate = useMutation((val, onSelect) => props.patchUser({
        birthdate: val ? val.format('YYYY-MM-DD') : null,
    }), {
        onSuccess: (_data, val, onSelect) => {
            onSelect(val);
        },
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.party),
    });
    return !props.customer.isCompany &&
        props.user.relation !== 'alternative-contact' ? (React.createElement(UserInfoEntity, { title: lang.debtorInfo.birthdate, value: birthdate, onChange: (val) => { }, renderValue: () => birthdate ? (`${birthdate.format(THEME.DATE_FORMAT)} (${moment().diff(birthdate, 'years')} ${lang.debtorInfo.yearsOld})`) : (React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.noBirthdate)), renderEditor: (selectedValue) => (React.createElement(DateInput, { allowNull: true, disabled: patchBirthdate.isLoading, onChange: (val) => {
                setBirthdate(val);
                if (val == null || (val != null && val.isValid())) {
                    patchBirthdate.mutate(val, selectedValue);
                }
            }, value: birthdate ? birthdate : moment(), placeholder: lang.debtorInfo.birthdate, maxDate: new Date(), customDateFormat: "dd.MM.yyyy" })), removable: true })) : null;
};
export default UserBirthdate;
//# sourceMappingURL=UserBirthdate.js.map